import styled from 'styled-components';

export const StyledFPCard = styled.div`
  background: var(--surface);
  border-radius: var(--r-lg);
  box-shadow: var(--sh-1);
  padding: var(--s-5) var(--s-5) var(--s-4);
  width: 100%;
`;

/* Rate + bar side-by-side row */
export const StyledFPRateBar = styled.div`
  display: flex;
  align-items: center;
  gap: var(--s-5);
  margin-bottom: var(--s-4);
`;

export const StyledFPRateBlock = styled.div`
  flex: none;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`;

export const StyledFPRate = styled.div<{ $color?: string }>`
  font-size: var(--t-5xl);
  font-weight: var(--weight-bold);
  letter-spacing: -0.03em;
  line-height: 1;
  color: ${({ $color }) => $color ?? 'var(--brand-green)'};
  font-variant-numeric: tabular-nums;

  span {
    font-size: var(--t-2xl);
    color: var(--muted);
    font-weight: var(--weight-semibold);
  }
`;

export const StyledFPEyebrow = styled.span`
  font-size: var(--t-xs);
  font-weight: var(--weight-semibold);
  letter-spacing: var(--tracking-eyebrow);
  text-transform: uppercase;
  color: var(--muted);
  margin-top: var(--s-1);
`;

export const StyledFPBarWrapper = styled.div`
  flex: 1;
  min-width: 0;
`;

export const StyledFPBar = styled.div`
  display: flex;
  height: 14px;
  border-radius: var(--r-full);
  overflow: hidden;
  background: var(--paper);
  gap: 2px;
`;

export const StyledFPBarSegment = styled.div<{ color: string; width: string }>`
  height: 100%;
  width: ${({ width }) => width};
  background: ${({ color }) => color};
  flex-shrink: 0;
  border-radius: 2px;
  transition: width 0.6s var(--ease-out);
`;

export const StyledFPBarMeta = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: var(--s-2);
  margin-top: var(--s-2);
  font-size: var(--t-xs);
  color: var(--muted);

  strong {
    color: var(--ink);
    font-weight: var(--weight-bold);
  }
`;

export const StyledFPSegments = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: var(--s-3);
  margin-bottom: var(--s-4);

  @media (max-width: 680px) {
    grid-template-columns: repeat(2, 1fr);
  }
`;

export const StyledFPSegmentCard = styled.div<{ bg: string; borderColor: string }>`
  padding: var(--s-3) var(--s-4);
  border-left: 3px solid ${({ borderColor }) => borderColor};
  background: ${({ bg }) => bg};
  border-radius: var(--r-sm);
`;

export const StyledFPSegmentTop = styled.div`
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  margin-bottom: 4px;
`;

export const StyledFPSegmentCount = styled.span`
  font-size: var(--t-2xl);
  font-weight: var(--weight-bold);
  letter-spacing: -0.02em;
  line-height: 1;
  color: var(--ink);
`;

export const StyledFPSegmentPct = styled.span`
  font-size: var(--t-xs);
  font-weight: var(--weight-semibold);
  color: var(--muted-2);
`;

export const StyledFPSegmentLabel = styled.span`
  font-size: var(--t-xs);
  color: var(--muted);
  font-weight: var(--weight-medium);
`;

export const StyledFPAlert = styled.div`
  display: flex;
  align-items: center;
  gap: var(--s-3);
  padding: var(--s-3) var(--s-4);
  background: var(--danger-soft);
  border-radius: var(--r-md);
  border: 1px solid rgba(215, 74, 71, 0.18);
`;

export const StyledFPAlertIconTile = styled.div`
  flex-shrink: 0;
  width: 32px;
  height: 32px;
  border-radius: var(--r-sm);
  background: rgba(212, 121, 116, 0.12);
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--danger);

  svg {
    width: 16px;
    height: 16px;
    fill: none;
    stroke: currentColor;
    stroke-width: 2px;
    stroke-linecap: round;
    stroke-linejoin: round;
  }
`;

export const StyledFPSeeAllLink = styled.button`
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;
  font-family: inherit;
  font-size: var(--t-sm);
  font-weight: var(--weight-medium);
  color: var(--ink-2);
  display: inline-flex;
  align-items: center;
  gap: var(--s-1);
  transition: color var(--dur-fast) var(--ease-out);
  white-space: nowrap;

  &:hover {
    color: var(--ink);
  }
`;

export const StyledFPAlertBody = styled.div`
  flex: 1;
  min-width: 0;
`;

export const StyledFPAlertText = styled.div`
  font-size: var(--t-sm);
  color: var(--muted);
  line-height: 1.5;

  strong {
    font-weight: var(--weight-semibold);
    color: var(--danger);
  }
`;

export const StyledFPAlertAction = styled.button`
  flex-shrink: 0;
  padding: var(--s-2) var(--s-4);
  border-radius: var(--r-sm);
  border: none;
  background: var(--danger);
  color: var(--surface);
  font-size: var(--t-sm);
  font-weight: var(--weight-semibold);
  cursor: pointer;
  transition: opacity var(--dur-fast) var(--ease-out);
  white-space: nowrap;

  &:hover {
    opacity: 0.88;
  }
`;
